import React, { ReactNode } from 'react';
import c from 'classnames';
import './index.scss';

type RecoveryModeWrapperProps = {
  children: ReactNode;
  active: boolean;
};

export const RecoveryModeWrapper: React.FC<RecoveryModeWrapperProps> = ({ children, active }) => (
  <div
    className={c('recovery-mode-wrapper', {
      'recovery-mode-wrapper--active': active,
    })}
  >
    {children}
  </div>
);
